module.exports = __webpack_public_path__ + "img/book_end_date.5729b682.png";